import { render, staticRenderFns } from "./articol.vue?vue&type=template&id=2743358e&scoped=true&"
import script from "./articol.vue?vue&type=script&lang=js&"
export * from "./articol.vue?vue&type=script&lang=js&"
import style0 from "./articol.vue?vue&type=style&index=0&id=2743358e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743358e",
  null
  
)

export default component.exports